import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class GetGiftingUndeliverableDates {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * GetGiftingUndeliverableDates constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Check if requested password is not blacklisted.
     *
     * @returns {Promise}
     */
    handle() {
        let apiUrl = ApiEndpoints['gifting.undeliverable-dates.index'];

        return this.apiService.get(apiUrl);
    }
}
